import React from "react";

interface TrashIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const TrashIcon = ({
    className = "",
    color = "currentColor",
    size = "md",
}: TrashIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",       // ~16x16px
        md: "w-4.5 h-4.5",   // ~18x18px
        lg: "w-6 h-6",       // ~24x24px
        xl: "w-8 h-8",       // ~32x32px
    };

    return (
        <div className="icon trash-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M3 6h18" />
                <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" />
                <path d="M19 6l-1 14c-.1 1.1-1 2-2.1 2H8.1c-1.1 0-2-.9-2.1-2L5 6" />
                <path d="M10 11v6M14 11v6" />
            </svg>
        </div>
    );
};

export default TrashIcon;
